(() => {
  // Prefer Shopify's format from theme settings, but don't rely on Shopify.formatMoney existing.
  const moneyFormat =
    window.Shopify?.money_format ||
    document.documentElement.getAttribute("data-money-format") ||
    "${{amount}}";

  const formatMoney = (cents) => {
    if (typeof cents !== "number") return "";

    // Handle common Shopify placeholders:
    // {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}, etc.
    const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = placeholderMatch ? placeholderMatch[1] : "amount";

    const precisionMap = {
      amount: 2,
      amount_no_decimals: 0,
      amount_with_comma_separator: 2,
      amount_no_decimals_with_comma_separator: 0,
      amount_with_apostrophe_separator: 2,
      amount_no_decimals_with_apostrophe_separator: 0,
      amount_with_space_separator: 2,
      amount_no_decimals_with_space_separator: 0
    };

    const precision = precisionMap[placeholder] ?? 2;

    const raw = (cents / 100).toFixed(precision);

    const formatWithSeparators = (value, thousands, decimal) => {
      const parts = value.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length === 2 ? parts[0] + decimal + parts[1] : parts[0];
    };

    let formatted = raw;

    // Separator styles
    if (placeholder.includes("comma_separator")) {
      formatted = formatWithSeparators(raw, ".", ",");
    } else if (placeholder.includes("apostrophe_separator")) {
      formatted = formatWithSeparators(raw, "'", ".");
    } else if (placeholder.includes("space_separator")) {
      formatted = formatWithSeparators(raw, " ", ".");
    } else {
      formatted = formatWithSeparators(raw, ",", ".");
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  };

  const closestScope = (el) => el?.closest(".shopify-section") || el?.closest("section") || document;

  document.addEventListener("sealsubs:price_update", (e) => {
    const d = e?.detail || {};
    const widgetEl = d.element;

    const priceCents = d.price;           // subscription/current price
    const compareCents = d.compareAtPrice; // regular price

    if (typeof priceCents !== "number") return;

    const scope = closestScope(widgetEl);
    const priceWrap =
      scope.querySelector("[data-kk-price-sync]") ||
      scope.querySelector(".product__price") ||
      scope.querySelector(".price");

    if (!priceWrap) return;

    const regularWrap = priceWrap.querySelector("[data-kk-price-regular-wrap]");
    const saleWrap = priceWrap.querySelector("[data-kk-price-sale-wrap]");
    const regularEl = priceWrap.querySelector("[data-kk-price-regular]");
    const saleEl = priceWrap.querySelector("[data-kk-price-sale]");
    const compareEl = priceWrap.querySelector("[data-kk-price-compare]");

    const hasCompare = typeof compareCents === "number" && compareCents > priceCents;

    // Toggle UI blocks
    if (regularWrap && saleWrap) {
      saleWrap.classList.toggle("hidden", !hasCompare);
      regularWrap.classList.toggle("hidden", hasCompare);
    }

    // Update numbers
    if (saleEl) saleEl.textContent = formatMoney(priceCents);

    if (compareEl) {
      compareEl.textContent = hasCompare ? formatMoney(compareCents) : "";
    }

    if (regularEl) {
      // When not in sale mode, regular shows the current price
      regularEl.textContent = hasCompare ? formatMoney(compareCents) : formatMoney(priceCents);
    }

    // Keep Broadcast classes consistent (helps styling/badges)
    priceWrap.classList.toggle("price--on-sale", hasCompare);
    priceWrap.classList.toggle("product__price--sale", hasCompare);
  });
})();
